import { useAuth } from "../context/AuthContext";
import {
  APPROVED_THROUGH_DIY_FLOW_USER_STATUS,
  APPROVED_USER_STATUS,
  ONBOARDING_USER_STATUS,
} from "../utils/constants";
import { dashboardRoutes } from "../routes/DashboardRoutes";
import { Navigate } from "react-router-dom";
import { isReviewOrRejectedOnboardingStatus } from "../utils/onboardingRouting";
import { isAdminUser } from "../utils/userTypeUtils";

const DefaultRedirect = () => {
  const { user } = useAuth();
  const isAdmin = isAdminUser(user);

  if (isAdmin) {
    if (user?.data?.parent_brand?.id || user?.data?.brand?.id) {
      return <Navigate to="/campaign/home" replace />;
    }
    return <Navigate to="/creators/discover" replace />;
  }

  if (isReviewOrRejectedOnboardingStatus(user?.data?.status)) {
    return <Navigate to="/register/status" replace />;
  }

  const isApprovedUser =
    user?.data?.status === APPROVED_USER_STATUS ||
    user?.data?.status === APPROVED_THROUGH_DIY_FLOW_USER_STATUS;

  if (isApprovedUser && (user?.data?.brand || user?.data?.parent_brand?.id)) {
    return <Navigate to="/dashboard/home" replace />;
  }

  if (user?.data?.status === ONBOARDING_USER_STATUS) {
    if (!user?.data?.onboarding_application_id) {
      return <Navigate to="/register" replace />;
    }

    const onboardingFeatures = user.data?.features
      ? Object.keys(user.data.features)
      : [];

    if (onboardingFeatures.includes("creators")) {
      return <Navigate to="/creators/discover" replace />;
    }
    if (onboardingFeatures.includes("campaigns")) {
      return <Navigate to="/campaign/home" replace />;
    }

    const currentStep = user.data.current_onboarding_step || 1;
    const onboardingRoute = dashboardRoutes.find(
      (r) => r.path === "/onboarding",
    );
    const currentStepRoute = onboardingRoute?.routes.find(
      (r) => r.stepNumber === currentStep,
    );

    if (currentStepRoute) {
      return <Navigate to={`/onboarding/${currentStepRoute.path}`} replace />;
    }
    const fallbackStepRoute =
      onboardingRoute?.routes[onboardingRoute.routes.length - 1];
    //TODO: Check if it impaccts those whose last route is not accessible?
    return <Navigate to={`/onboarding/${fallbackStepRoute?.path}`} replace />;
  }
  const features = user.data?.features ? Object.keys(user.data?.features) : [];
  if (features.includes("campaigns")) {
    return <Navigate to="/campaign/home" replace />;
  }
  if (features.includes("creators")) {
    return <Navigate to="/creators/discover" replace />;
  }
  if (features.includes("analytics")) {
    return <Navigate to="/analytics/sales-tracker" replace />;
  }
  if (features.length > 0) {
    return <Navigate to={`/${features[0]}`} replace />;
  }
  return <Navigate to="/help" replace />;
};

export default DefaultRedirect;
